import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IProductType, ProductType } from '../../../../models/productType.model';
import { ProductTypeService } from '../../../../services/productType.service';
import { Category, ICategory } from '../../../../models/category.model';
import { CategoryService } from '../../../../services/category.service';
import { ICharacteristics } from '../../../../models/characteristics.model';
import Swal from 'sweetalert2';
import { NameValidator } from '../../validators/name.validator';
import { Validation } from '../../error/error-messages/validator-messages';
import { forkJoin, Observable } from 'rxjs';
import { ServiceService } from '../../../../services/service.service';

@Component({
  selector: 'app-sub-category',
  templateUrl: './sub-category.component.html',
  styleUrls: ['./sub-category.component.scss']
})
export class SubCategoryComponent implements OnInit {
  @ViewChild('closeeditbutton4') closeeditbutton4: ElementRef;
  @ViewChild('editSubCategoryModal') editSubCategoryModal: any;

  productType: ProductType[] = [];
  productTypeTemp: ProductType[] = [];
  categories: ICategory[] = [];
  characteristics: ICharacteristics[] = [];
  perPage: number = 10;
  page: number = 1;
  productTypeForm: FormGroup;

  skillsForm: FormGroup;
  editForm: FormGroup;

  currentProductType: ProductType;

  productTypeSave = new ProductType();

  sorted = false;
  sorted1 = false;
  sorted2 = false;
  sorted3 = false;

  search: any;

  alreadyExist: boolean = false;
  dropdownSettings = {};
  dropdownSettingsSubCategorie = {};
  selectedProductService: any[] = [];
  productTypeAngularList: ProductType[] = [];
  selectedSubCategory: any[] = [];
  productTypeId: number
  subCategory: any[] = [];
  allProductService: any[] = [];
  allProduct!: any
  allService!: any
  statusSearchText = '';
  searchText = '';
  productTypes: ProductType;
  selectedItemType: string = '';
  filteredProductService: any[] = [];
  filteredSubCategories: any[] = [];

  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems: any;

  constructor(private productTypeService: ProductTypeService,
    private categoryService: CategoryService, private serviceService: ServiceService,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.loadProductType();
    this.loadCategory();
    this.loadFilteredProductTypes();

    this.productTypeForm = this.fb.group({
      name: new FormControl('', [Validators.required, NameValidator.notOnlyWhitespace, NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2)]),
      category: new FormControl('', Validators.required),
      type: new FormControl('', [Validation.requiredValidator("Veuillez choisir si c'est pour un produit ou un service."),]),
    });

    this.editForm = this.fb.group({
      name: new FormControl('', [Validators.required, NameValidator.notOnlyWhitespace, NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2)]),
      category: new FormControl('', Validators.required),
      type: new FormControl('', [Validation.requiredValidator("Veuillez choisir si c'est pour un produit ou un service.")]),
    });

    this.skillsForm = this.fb.group({
      name: new FormControl('', [Validators.required]),
      category: new FormControl('', [Validators.required]),
      productTypeCharacteristics: this.fb.array([]),
    });
    this.dropdownSettings = {
      singleSelection: false,
      text: "Sélectionnez un produit/service",
      searchPlaceholderText: "Recherchez...",
      selectAllText: 'Tout sélectionner',
      unSelectAllText: 'Tout désélectionner',
      enableSearchFilter: true,
      classes: "myclass custom-class",
      textField: 'variantName', // Utilise le nom du variant
      idField: 'variantID',     // Utilise l'ID du variant
      labelKey: 'variantName',  // Utilise le nom du variant pour l'affichage
      primaryKey: 'variantID'
    };
    this.dropdownSettingsSubCategorie = {
      singleSelection: true,
      limitSelection: 1,
      text: "Sélectionnez une sous-catégorie",
      searchPlaceholderText: "Recherchez...",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      textField: 'name',
      idField: 'id',
      labelKey: 'name',
      primaryKey: 'id',
    };
  }

  onItemTypeChange(type: string) {
    if(type==null || type == undefined || type == "") {
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Veuillez définir le type pour la sous catégorie',
        timer: 3000
      });
      return;
    }
    this.selectedProductService = []; // Réinitialiser la sélection quand le type change
    this.selectedSubCategory = []; // Réinitialiser la sélection de sous-catégorie
    this.selectedItemType = type
    console.log("this.selectedItemType", this.selectedItemType)
    console.log("type", type)
    // Filtrer les produits/services selon le type
    if (this.selectedItemType === 'product') {
      this.filteredProductService = this.allProduct || [];
      this.dropdownSettings = {
        ...this.dropdownSettings,
        text: "Sélectionnez des produits",
        searchPlaceholderText: "Rechercher un produit..."
      };
      // Filtrer les sous-catégories pour n'avoir que celles de type produit
      this.filteredSubCategories = this.productTypeAngularList.filter(subCat =>
        subCat.type === 'product' && subCat.id !== this.productTypeId
      );
    } else if (this.selectedItemType === 'service') {
      this.filteredProductService = this.allService || [];
      this.dropdownSettings = {
        ...this.dropdownSettings,
        text: "Sélectionnez des services",
        searchPlaceholderText: "Rechercher un service..."
      };
      // Filtrer les sous-catégories pour n'avoir que celles de type service
      this.filteredSubCategories = this.productTypeAngularList.filter(subCat =>
        subCat.type === 'service' && subCat.id !== this.productTypeId
      );
    }
  }

  openEditSubCategoryModal(productType: ProductType) {

    if(productType.type==null || productType.type == undefined || productType.type == "") {
      return
    }
    this.productTypeId = productType.id;
    this.selectedItemType = ''; // Réinitialiser le type
    this.selectedProductService = []; // Réinitialiser la sélection
    this.selectedSubCategory = []; // Réinitialiser la sélection de sous-catégorie
    this.loadProductServicesBySubCategory(productType.id);
    this.editSubCategoryModal.show();
  }

  loadFilteredProductTypes() {
    this.productTypeService.getProductType().subscribe({
      next: (data: any) => {
        // Stocker toutes les sous-catégories sauf la courante
        this.productTypeAngularList = data.filter((type: ProductType) =>
          type.id !== this.productTypeId
        );
        this.filteredSubCategories = this.productTypeAngularList; // Initialisation
      },
      error: (err) => {
        console.error('Erreur lors du chargement des sous-catégories:', err);
        Swal.fire({
          title: 'Erreur',
          text: 'Impossible de charger les sous-catégories',
          icon: 'error',
          timer: 4000,
          timerProgressBar: true
        });
      }
    });
  }

  loadProductServicesBySubCategory(subCategoryId: number) {
    if (!subCategoryId) return;

    this.productTypeService.getProductTypeVariants(subCategoryId).subscribe({
      next: (data: any) => {
        this.productTypes = data;

        this.allProduct = this.productTypes.products.map(val => ({
          variantName: val.name,
          variantID: val.productID,
          id: val.id,
          category: val.category,
          variantType: "product",
        }));

        this.allService = this.productTypes.services.map(val => ({
          id: val.id,
          variantName: val.titre,
          variantID: val.serviceID,
          category: val.category,
          variantType: "service",
        }));

        this.allProductService = [...this.allProduct, ...this.allService];
        this.filteredProductService = this.allProductService; // Initialisation
        this.totalItems = this.allProductService.length;
      },
      error: (err) => {
        console.error('Erreur lors du chargement des produits/services:', err);
      }
    });
  }

  // moveToNewSubCategory() {
  //   if (!this.selectedSubCategory || this.selectedSubCategory.length === 0) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Erreur',
  //       text: 'Veuillez sélectionner une sous-catégorie de destination',
  //       timer: 3000
  //     });
  //     return;
  //   }
  //   const targetSubCategoryId = this.selectedSubCategory[0].id;
  //   const selectedItems = this.selectedProductService;
  //   if (selectedItems.length === 0) {
  //     Swal.fire({
  //       icon: 'warning',
  //       title: 'Attention',
  //       text: 'Aucun élément sélectionné pour le déplacement',
  //       timer: 3000
  //     });
  //     return;
  //   }
  //   // Séparer les produits et services sélectionnés
  //   const productItems = selectedItems.filter(item => item.variantType === 'product');
  //   const serviceItems = selectedItems.filter(item => item.variantType === 'service');

  //   // Créer une liste de ProductType pour l'API
  //   const productTypeListForProducts: ProductType[] = productItems.map(item => ({
  //     id: item.variantID,
  //     name: item.variantName,
  //   }));
  //   const productTypeListForServices: ProductType[] = serviceItems.map(item => ({
  //     id: item.variantID,
  //     name: item.variantName,
  //   }));
  //   Swal.fire({
  //     title: 'Confirmation',
  //     text: `Voulez-vous déplacer ${selectedItems.length} élément(s) vers la sous-catégorie sélectionnée?`,
  //     icon: 'question',
  //     showCancelButton: true,
  //     confirmButtonText: 'Oui, déplacer',
  //     cancelButtonText: 'Annuler'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const observables: Observable<any>[] = [];
  //       // Traiter les produits si présents
  //       if (productTypeListForProducts.length > 0) {
  //         observables.push(this.productTypeService.updateSubCategoryProduct(
  //           productTypeListForProducts,
  //           targetSubCategoryId
  //         ));
  //       }
  //       // Traiter les services si présents
  //       if (productTypeListForServices.length > 0) {
  //         observables.push(this.serviceService.updateSubCategoryService(
  //           productTypeListForServices,
  //           targetSubCategoryId
  //         ));
  //       }
  //       // Exécuter les requêtes
  //       if (observables.length > 0) {
  //         forkJoin(observables).subscribe({
  //           next: () => {
  //             Swal.fire({
  //               icon: 'success',
  //               title: 'Succès',
  //               text: 'Les éléments ont été déplacés avec succès',
  //               timer: 2000
  //             });
  //             // Recharger les données
  //             this.loadProductServicesBySubCategory(this.productTypeId);
  //             // Réinitialiser les sélections
  //             this.selectedProductService = [];
  //             this.selectedSubCategory = [];
  //             // Fermer le modal
  //             this.editSubCategoryModal.hide();
  //           },
  //           error: (error) => {
  //             console.error('Erreur lors du déplacement:', error);
  //             Swal.fire({
  //               icon: 'error',
  //               title: 'Erreur',
  //               text: 'Une erreur est survenue lors du déplacement des éléments',
  //               timer: 3000
  //             });
  //           }
  //         });
  //       }
  //     }
  //   });
  // }

  moveToNewSubCategory() {
    // Vérification des sélections
    if (!this.selectedProductService?.length || !this.selectedSubCategory?.length) {
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Veuillez sélectionner au moins un élément et une sous-catégorie de destination',
        timer: 3000
      });
      return;
    }
  
    const targetSubCategoryId = this.selectedSubCategory[0].id;
    
    // Séparer les produits et services
    const productItems = this.selectedProductService.filter(item => item.variantType === 'product');
    const serviceItems = this.selectedProductService.filter(item => item.variantType === 'service');

    const allProductToMove = productItems.map(val => ({
      id: val.id,
      name: val.variantName,
      category: val.category,
      productID: val.variantID,
    }));

    const allServiceToMove = serviceItems.map(val => ({
      id: val.id,
      titre: val.variantName,
      category: val.category,
      serviceID: val.variantID,
    }));

    // Extraire uniquement l'ID du premier élément de chaque type
    console.log("allProductToMove", allProductToMove)
    const productsToMove = productItems[0]?.variantID;
    const servicesToMove = serviceItems[0]?.variantID;
  
    Swal.fire({
      title: 'Confirmation',
      text: `Voulez-vous déplacer les éléments sélectionnés vers la sous-catégorie sélectionnée?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Oui, déplacer',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        const observables: Observable<any>[] = [];
  
        // Ajouter la requête pour le produit si présent
        if (productsToMove) {
          console.log("productsToMove", productsToMove)
          observables.push(
            this.productTypeService.updateSubCategoryProduct(allProductToMove, targetSubCategoryId)
          );
        }
  
        // Ajouter la requête pour le service si présent
        if (servicesToMove) {
          observables.push(
            this.serviceService.updateSubCategoryService(allServiceToMove, targetSubCategoryId)
          );
        }
  
        // Exécuter les requêtes
        if (observables.length > 0) {
          forkJoin(observables).subscribe({
            next: () => {
              Swal.fire({
                icon: 'success',
                title: 'Succès',
                text: 'Les éléments ont été déplacés avec succès',
                timer: 2000
              });
  
              // Rafraîchir les données
              this.loadProductServicesBySubCategory(this.productTypeId);
              
              // Réinitialiser les sélections
              this.selectedProductService = [];
              this.selectedSubCategory = [];
              
              // Fermer le modal
              this.editSubCategoryModal.hide();
            },
            error: (error) => {
              console.error('Erreur lors du déplacement:', error);
              Swal.fire({
                icon: 'error',
                title: 'Erreur',
                text: 'Une erreur est survenue lors du déplacement des éléments',
                timer: 3000
              });
            }
          });
        }
      }
    });
  }
  
  private handleSuccess() {
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: 'Éléments déplacés avec succès',
      showConfirmButton: false,
      timer: 1500
    });
    
    // Rafraîchir et réinitialiser
    this.loadProductServicesBySubCategory(this.productTypeId);
    this.selectedProductService = [];
    this.selectedSubCategory = [];
    this.editSubCategoryModal.hide();
  }
  
  private handleError(error: any) {
    console.error('Erreur lors du déplacement:', error);
    Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: 'Erreur lors du déplacement',
      text: 'Veuillez réessayer.',
      showConfirmButton: false,
      timer: 2500
    });
  }
  // Only AlphaNumeric
  keyPressAlphanumeric(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (!/[!@#$%°£§^&*$0-9()_+\=\[\]{};:"\\|,.<>\/?]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  get productTypeName() {
    return this.productTypeForm.get('name');
  }

  get categoryName() {
    return this.productTypeForm.get('category');
  }

  get subCategorieType() {
    return this.productTypeForm.get('type');
  }

  sort1() {
    if (this.sorted1 == false) {
      // @ts-ignore
      this.productType.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.productType.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0)
      this.sorted1 = false;
    }
  }
  sort2() {
    if (this.sorted2 == false) {
      // @ts-ignore
      this.productType.sort((a, b) => a.category.name > b.category.name ? 1 : a.category.name < b.category.name ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.productType.sort((a, b) => a.category.name < b.category.name ? 1 : a.category.name > b.category.name ? -1 : 0)
      this.sorted2 = false;
    }
  }

  sort3() {
    if (this.sorted3 == false) {
      // @ts-ignore
      this.productType.sort((a, b) => a.type > b.type ? 1 : a.type < b.type ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.productType.sort((a, b) => a.type < b.type ? 1 : a.type > b.type ? -1 : 0)
      this.sorted3 = false;
    }
  }

  loadProductType() {
    this.productTypeService.getProductType().subscribe((data: any) => {
      // console.log(data)
      this.productType = data;
      this.productTypeTemp = this.productType;
    }, (err) => {
      //  console.log('-----> err', err);
    });
  }

  loadCategory() {
    this.categoryService.getCategoryAll().subscribe(data => {
      this.categories = data;
    }, error => {
      // console.log(error);
    })
  }

  deleteProductType(id: number) {
    // console.log(id);

    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer cette sous-catégorie ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.productTypeService.deleteProductType(id).subscribe(
          rs => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'La sous-catégorie produit a été supprimée avec succès"',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadProductType();
          }, error => {
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 2500
            })
          }
        );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',
        })
      }
    });
  }

  deleteCharacteristicByProductType(id: number) {
    // console.log(id);

    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer tous les caractéristiques associées à cette sous-catégorie ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.productTypeService.deleteCharacteristicByProductType(id).subscribe(
          rs => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Les caractéristiques ont été supprimée avec succès"',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadProductType();
          }, error => {
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 2500
            })
          }
        );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',
        })
      }
    });
  }


  selectedProductName: string
  getName(name: string) {
    this.selectedProductName = name;
  }

  onDetailProductType(p: IProductType) {
    this.currentProductType = p;
    this.productTypeService.getCharacteristicsBySubProductId(p.id).subscribe(data => {
      this.characteristics = data;
    })
  }

  onEditProductType(p: ProductType) {
    //console.log(p)
    this.currentProductType = p;
    this.editForm.patchValue({
      name: this.currentProductType.name,
      category: this.currentProductType.category.id,
      type: this.currentProductType.type,
    });
  }

  get editProductTypeName() {
    return this.editForm.get('name');
  }

  get editCategoryName() {
    return this.editForm.get('category');
  }

  onSubmit() {

  }

  addSkills() {

  }

  removeSkill(i: number) {

  }

  displayPerPage(value: string) {
    this.perPage = Number(value);
  }

  searchFilter($event: KeyboardEvent) {
    this.productType = this.productTypeTemp.filter(value =>
      value?.name.toLowerCase().trim().includes(this.search.toLowerCase().trim()) ||
      value?.category?.name.toLowerCase().trim().includes(this.search.toLowerCase().trim())
    );
  }

  normalizeString(str) {
    return str
      .toLowerCase()
      .replace(/[àáâãäå]/g, "a")
      .replace(/[ç]/g, "c")
      .replace(/[èéêë]/g, "e")
      .replace(/[ìíîï]/g, "i")
      .replace(/[ñ]/g, "n")
      .replace(/[òóôõö]/g, "o")
      .replace(/[ùúûü]/g, "u")
      .replace(/[ýÿ]/g, "y")
      .replace(/[^a-z0-9]/g, ""); // Supprime tous les caractères qui ne sont pas des lettres ou des chiffres
  }

  saveProductType() {
    const productType: ProductType = this.productTypeForm.value;

    const category: Category = this.categories.find(c => c.id === Number(productType.category));
    const productTypeNameNormalized = this.normalizeString(productType.name);
    const subCategory: ProductType = this.productType.find(pt => this.normalizeString(pt.name) === productTypeNameNormalized);

    if (subCategory !== undefined && category.id === subCategory.category.id) {
      this.alreadyExist = true;
      return;
    } else {
      this.alreadyExist = false;
    }

    this.productTypeSave.name = productType.name;
    this.productTypeSave.category = category;
    this.productTypeSave.type = productType.type;

    // console.log("Sous catégorie enregistrer :");
    // console.log(this.productTypeSave);

    this.productTypeService.saveProductType(this.productTypeSave).subscribe(rs => {
      // console.log("~~~~~~~~~~Sous catégorie~~~~~~~~~~");
      // console.log(this.productTypeSave);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'La sous-catégorie a été ajoutée avec succès"',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadProductType();
      this.clearAndCloseModal();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de l\'ajout de la sous-catégorie ',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  clearAndCloseModal() {
    document.getElementById('closebutton2')?.click();
    /*this.productTypeForm.patchValue({
      name: [''],
      category: new FormControl([''])
    });*/
    this.productTypeForm.reset();
    this.alreadyExist = false;
  }

  onEditFormSubmit() {
    const name = this.editForm.get('name')?.value?.trim();
    const categoryValue = this.editForm.get('category')?.value;
    const type = this.editForm.get('type')?.value;

    const category = this.categories.find(cat => cat.id === Number(categoryValue));

    const productTypeNameNormalized = this.normalizeString(name);
    const subCategory: ProductType = this.productType.find(pt => this.normalizeString(pt.name) === productTypeNameNormalized);

    // if(subCategory !== undefined && category.id === subCategory.category.id){
    //   this.alreadyExist = true;
    //   return;
    // }else{
    //   this.alreadyExist = false;
    // }

    if (this.editForm.invalid) {
      this.editForm.markAllAsTouched();
      return;
    }

    this.currentProductType.name = name;
    this.currentProductType.category = category;
    this.currentProductType.type = type;

    // console.log("Sous-categorie modifiée");
    // console.log(this.currentProductType)

    this.productTypeService.updateProductType(this.currentProductType).subscribe(rs => {
      this.close();
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'La sous-catégorie a été modifié avec succès"',
        showConfirmButton: false,
        timer: 1500
      });

      this.close();
      //this.clearAndCloseModalEdit();
      this.loadProductType();

    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez vérifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  close() {
    this.closeeditbutton4.nativeElement.click();
    // this.closebutton2.nativeElement.click();
  }
  clearAndCloseModalEdit() {
    document.getElementById('closeeditbutton4')?.click();
    this.editForm.patchValue({
      name: [''],
      category: ['']
    });
  }

  onItemSelect(item: any) {
    console.log("Produit/Service sélectionné:", item);
    // Vous pouvez ajouter ici la logique pour gérer la sélection
  }
  OnItemDeSelect(item: any) {
  }
  onSelectAll(items: any) {
  }
  onDeSelectAll(items: any) {
  }

  onSubCategorySelect(event: any) {
    // this.selectedCategory = event;
    // console.log('Catégorie sélectionnée :', this.selectedCategory);
  }
  OnItemDeSelectSubCategorie(item: any) {
  }
}
